import { Reveal, SectionLabel } from "@/components/Reveal";

const sections = [
  {
    title: "Données collectées",
    content: [
      "Via le formulaire de prise de rendez-vous : nom, adresse email, numéro de téléphone, profil (professionnel ou particulier), nature de vos besoins et message libre.",
      "Ces données sont transmises uniquement avec votre accord, lorsque vous soumettez le formulaire.",
    ],
  },
  {
    title: "Finalité du traitement",
    content: [
      "Vos données servent exclusivement à organiser et confirmer votre rendez-vous, ainsi qu'à préparer notre échange. Elles peuvent être inscrites dans l'agenda professionnel d'Aurélie Violet (Google Agenda).",
      "Elles ne sont jamais vendues, cédées ou utilisées à des fins publicitaires.",
    ],
  },
  {
    title: "Durée de conservation",
    content: [
      "Les données liées à un rendez-vous sont conservées le temps nécessaire à la relation commerciale, puis supprimées sur simple demande.",
    ],
  },
  {
    title: "Vos droits (RGPD)",
    content: [
      "Conformément au Règlement Général sur la Protection des Données, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition concernant vos données personnelles.",
      "Pour exercer ces droits : a.violet@aadprox.com. Vous pouvez également saisir la CNIL (cnil.fr).",
    ],
  },
  {
    title: "Cookies",
    content: [
      "Ce site n'utilise aucun cookie publicitaire ou de suivi. Seul un cookie technique de session est utilisé pour l'espace professionnel de la gérante.",
    ],
  },
  {
    title: "Sécurité",
    content: [
      "Les échanges avec le site sont chiffrés (HTTPS). L'accès aux réservations est protégé et réservé à la gérante.",
    ],
  },
];

export default function PolitiqueConfidentialite() {
  return (
    <div className="mx-auto max-w-3xl px-6 pb-24 pt-16 lg:pt-24" data-testid="politique-confidentialite-page">
      <Reveal>
        <SectionLabel>Vos données</SectionLabel>
        <h1 className="mt-6 font-display text-4xl font-bold tracking-tight text-argia-ink sm:text-5xl">Politique de confidentialité</h1>
        <p className="mt-5 text-base text-argia-muted">Dernière mise à jour : août 2026</p>
      </Reveal>
      <div className="mt-12 space-y-10">
        {sections.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.06}>
            <section>
              <h2 className="font-display text-xl font-bold text-argia-ink">{s.title}</h2>
              <div className="mt-3 space-y-2">
                {s.content.map((p) => (
                  <p key={p} className="text-base leading-relaxed text-argia-muted">{p}</p>
                ))}
              </div>
            </section>
          </Reveal>
        ))}
      </div>
    </div>
  );
}
